const Form074SC = {
    stepName: {
        importantNotes: "重要事项",
        selectSchool: "选择学校类别",
        basicInfo: "基本资料",
        confirmation: "确认页面",
    },
    label: {
        noteHeader: {
            header1: "教育局通告第6/2010号",
            header2:
                "资助学校人员(以行政津贴／修订行政津贴聘用者)的公积金／强制性公积金雇主供款津贴发放及会计安排",
            header3: "[注意：本通告应交：",
            header4: "(a)各资助学校校监及校长 — 备办；以及",
            header5: "(b)各组主管 — 备考。]",
        },
        noteTitle: {
            title1: "摘要",
            title2: "背景",
            title3: "详情",
            title4: "查询",
        },
        noteList: {
            refNo: "档号： FIN(RS)/F&A/65/63",
            EDB: "",
            date: "二零一零年七月六日",
            note1: "本通告旨在阐述资助学校人员(以行政津贴／修订行政津贴聘用者)的公积金／强制性公积金(强积金)雇主供款津贴发放及会计安排。本通告应与现行有关资助学校人员退休福利拨款安排的教育局通告一并阅读。",
            note2: "资助学校获发行政津贴／修订行政津贴，目的是向以这些津贴聘用的人员支付薪金。此外，资助学校亦另获津贴，用作支付上述人员的公积金／强积金雇主供款实际开支。",
            note3: "由2010/11学年起，公积金／强积金雇主供款津贴发放程序会精简，以减省资助学校的行政工作。",
            note4: "修订的发放及会计安排如下：",
            note5: "学校应在每年八月十五日之前，就所有以行政津贴／修订行政津贴聘用的人员，向教育局经常津贴组提交<u>下学年</u>公积金／强积金雇主供款暂定全年数额申领表(载于附件1)。有关表格可于教育局网页下载(学校行政及管理＞行政规则＞资助则例＞与中、小、特殊学校资助则例相关的指引和表格)；",
            note6: "在填写上文(a)项的申领表时，学校应就其所知，提供下学年公积金／强积金雇主供款的最新预算，并签署证明所提供的资料正确无误及符合有关通告的规定。学校<u>无须</u>向经常津贴组提交薪金及公积金／强积金供款的支付证明文件，但文件应予保留；",
            note7: "按(a)项的暂定申领额，学校会在同一时间获发行政津贴／修订行政津贴及公积金／强积金雇主供款津贴，即设有法团校董会的学校分四期在九月、十一月、二月和五月获发津贴，而未设有法团校董会的学校则由九月份起每月获发津贴；",
            note8: "学校应继续按现行通函所要求，在提交经审核的账目内加入附表，详述以行政津贴／修订行政津贴聘用者的资料，以及与其相关的公积金／强积金供款，以便提交教育局学校核数组；以及",
            note9: "学校获发的津贴如有盈余，须退还教育局；如有不足之数，则在学校核数组查阅经审核的账目后获得发还。",
            note10: "如对本通告有任何查询，请与经常津贴组聯络：",
            note11: "小学",
            note12: "2892 6232",
            note13: "中学",
            note14: "2892 6233",
            note15: "特殊学校",
            note16: "2892 6234",
            note17: "教育局常任秘书长",
            note18: "曾周碧英代行",
        },
        noteNumber: {
            number2: "2.",
            number3: "3.",
            number4: "4.",
            number5: "5.",
            numbera: "(a)",
            numberb: "(b)",
            numberc: "(c)",
            numberd: "(d)",
            numbere: "(e)",
            numbera1: "a)",
            numberb1: "b)",
        },
        certifyList: {
            certify1: "兹证明以行政津贴／修订行政津贴支薪的人员会——",
            certify2:
                "在下学年获得的薪金中扣除以下雇员供款：5%的公积金供款，或不多于《强制性公积金计划条例》所订上限的强积金供款(视乎何者适用而定)。",
            certify3:
                "按以下规定获得公积金雇主供款：须符合现行有关资助学校人员退休福利拨款安排的教育局通告列明，按每名雇员在认可计划的条件下无间断供款的年资，以及按较高公积金雇主供款额的条件而计算。",
            certify4:
                "本人明白，补助只会提供予学校支付藉行政津贴／修订行政津贴聘用的人员的公积金／强积金供款，以及教育局会根据经审核的账目，发还公积金雇主供款津贴的实际不足之数，或收回未使用的津贴(视乎何者适用而定)。本表格所搜集的资料用以计算公积金／强积金雇主供款暂定全年数额及其他相关事宜，并可能会向其他政府部门／机构披露，以供核数／统计之用。",
        },
        detail: "公积金／强积金雇主供款暂定全年数额详情",
        totalSchoolYear: "学年总计",
        totalLastSchoolYear: "上学年总计",
        certify: "声明",
        tooltip:
            "公积金／强积金补助不适用于藉资助小学的「供增聘文书助理的行政津贴」聘用的人员",
        conditions: "本人已阅读、理解及同意上述条款及条件。",
        schoolType: "请选择学校类别：",
        schoolName: "学校名称",
        schoolCode: "学校代码",
        schoolYear: "学年",
        grantType: "适用于学校的津贴",
        rank: "职级",
        numStaff: "人员数目",
        provisionalAnnSal: "学年全年薪金暂定总额",
        provisionalAnnEmpCon: "公积金／强积金雇主供款暂定全年数额",
        totalNumStaff: "学年总计(人员数目)",
        totalNumStaff1: "人员数目",
        totalProvisionalAnnSal: "学年总计(学年全年薪金暂定总额)",
        totalProvisionalAnnSal1: "学年全年薪金暂定总额",
        totalProvisionalAnnEmpCon:
            "学年总计(公积金／强积金雇主供款暂定全年数额)",
        totalProvisionalAnnEmpCon1: "公积金／强积金雇主供款暂定全年数额",
        numStaffLastYr: "上学年总计(人员数目)",
        provisionalAnnSalLastYr: "上学年总计(学年全年薪金暂定总额)",
        provisionalAnnEmpConLastYr:
            "上学年总计(公积金／强积金雇主供款暂定全年数额)",
        schoolHead: "校长",
        supervisor: "校监",
        schoolHeadOrSupervisor: "校监／校长",
        schoolHeadName: "校长姓名",
        supervisorName: "校监姓名",
        schoolHeadOrSupervisorName: "校监／校长姓名",
        name: "姓名",
        date: "日期",
        contactPerson: "联络人",
        tel: "电话",
    },
    formContent: {
        schoolTypeOption: {
            primarySchool: "资助小学",
            secondarySchool: "资助中学",
            specialSchool: "资助特殊学校",
        },
        grantTypeOption: {
            administrationGrant: "行政津贴",
            revisedAdministrationGrant: "修订行政津贴",
        },
        schoolHeadOption: {
            schoolHead: "校长",
            supervisor: "校监",
        },
    },
    errorMsg: {
        telMax: "电话号码必须为最多12位数",
    },
};
export default Form074SC;
